/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Map_Embed_UrlInputs */

const vi_shop_contact_map_embed_url = /** @type {(inputs: Shop_Contact_Map_Embed_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL nhúng bản đồ (trang Liên hệ)`)
};

/**

* @param {Shop_Contact_Map_Embed_UrlInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_map_embed_url = /** @type {((inputs?: Shop_Contact_Map_Embed_UrlInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Map_Embed_UrlInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_map_embed_url(inputs)
});